const BasePrizeController = require('BasePrizeController');
const AudioMap = require('AudioMap');
const AudioManager = require('AudioManager');
const ParallaxController = require('ParallaxController');
const ParticleManager = require('ParticleManager');
const i18n = require('i18n');

const LandscapePrefix = 'gorizont';
const PortraitPrefix = 'vert';
const SmallPrefix = '2';
const SCALE_DOWN = { scale: 0 };
const SCALE_UP = { scale: 1 };
const SCALE_FLAG = { scale: 1.4 };
const SCALE_LABEL = { scale: 1.2 };
const ES_BACK_OUT = { easing: 'backOut' };
const ES_BACK_IN = { easing: 'backIn' };


cc.Class({
    extends: BasePrizeController,

    properties: {
        coinParticle: ParticleManager,
        parallax: ParallaxController,
        skeleton: sp.Skeleton,
        main: cc.Node,
        flag: cc.Node,
        labelParentContainer: cc.Node,
        lableNode: cc.Node,
        label: cc.Label,
        button: cc.Button,
    },

    onLoad() {
        this.audioMap = cc.find('AudioMap').getComponent(AudioMap);
        this.audioManager = cc.find('AudioManager').getComponent(AudioManager);
        this.winThresholds = [0, 20];

        this.skeleton.setCompleteListener((event) => {
            switch(this.skeleton.animation) {
                case 'TOTALgorizontStart':
                case 'TOTALvertStart':
                    this._playAnim('Idle');
                    break;
                case 'TOTAL2little':
                    this._playAnim('little')
            }
        });
        this.isClicked = false;
        this.onLandscape();
    },

    onLandscape() {
        this.isLandscape = true;
        this.prefix = LandscapePrefix;

        if (this.node.active) {
            this._playAnim();
        }
    },
    onPortrait() {
        this.isLandscape = false;
        this.prefix = PortraitPrefix;
        if (this.node.active) {
            this._playAnim();
        }
    },

    showPrize (prize, betAmount) {
        this.node.active = true;
        this.parallax.moveTo(0, 0, 1, 'backOut');
        this.prize = prize;
        this.main.active = false;
        this.flag.scale = 1.2;
        this.lableNode.scale = 1;
        let scale = 1;
        let l = prize.toString().length;
        if (l < 7) {
            scale = 1;
        } else if (l < 8) {
            scale = 0.9;
        } else if (l < 9) {
            scale = 0.82;
        } else if (l < 10) {
            scale = 0.7;
        } else if (l < 11) {
            scale = 0.64;
        } else if (l < 12) {
            scale = 0.58;
        } else if (l < 13) {
            scale = 0.5;
        } else if (l < 14) {
            scale = 0.45;
        } else if (l < 15) {
            scale = 0.4;
        } else if (l < 17) {
            scale = 0.3;
        } else {
            scale = 0.2;
        }
        this.labelParentContainer.scale = scale;
        const level = this._checkWinningLevel(prize, betAmount);
        this.prefix = level > 1? this.isLandscape? LandscapePrefix: PortraitPrefix: SmallPrefix;
        // this._playAnim(level > 3 ? 'Start': 'little');
        this.scheduleOnce(() => {
            this.audioMap.playSfx('fsTotalAppears');
            this._playAnim(level > 1 ? 'Start': 'little');

            this.main.active = true;
            this.main.scale = 0;
            cc.tween(this.main).delay(0.5).to(1, SCALE_UP, ES_BACK_OUT).start();
            cc.tween(this.flag).delay(2).to(1, SCALE_FLAG, ES_BACK_OUT).start();
            cc.tween(this.lableNode).delay(2.1).to(1, SCALE_LABEL, ES_BACK_OUT).start();

            if (level > 1) {
                this.coinParticle.play(50, 1000);
            }
        }, 0.2);
        this.isClicked = false;
        this.button.interactable = false;

        this.label.string = i18n.formatCurrencySmall(prize);

        this.scheduleOnce(() => {
            this.button.interactable = true;
            this.button.node.getComponent(cc.Widget).updateAlignment();
            this.node.once('click', this.finish, this);
            this.node.emit('freespinTotalPrizeEnd');
        }, 4);

        return new Promise(resolve => this.node.once('completed', resolve));
    },

    finish () {
        this.node.emit('finishing');
        this._finishAnimation();
    },

    _finishAnimation () {
        this.coinParticle.stop();
        cc.tween(this.main).to(0.3, SCALE_DOWN, ES_BACK_IN).start();
        this.parallax.moveTo(-20, 0, 1, 'sineInOut').then(() => {
            this.node.active = false;
            this.node.emit('completed');
        });
    },

    _playAnim(animName = null) {
        animName = animName || this._currentAnimName;

        this._currentAnimName = animName;

        this.skeleton.setAnimation(0, `TOTAL${this.prefix}${this._currentAnimName}`);
    },

    onClick() {
        if (this.isClicked) {
            return;
        }
        this.isClicked = true;
        this.node.emit('click');
    }
});
